export default __webpack_public_path__ + "static/media/snake2.18429be4.jpg";